import axios from 'axios';
import Cookies from 'js-cookie';
import { MessageBox } from 'element-ui';

function checkSubmittedApplication() {
    return axios.get('/zhaopinapi/job-applications/currently', {
        headers: { Authorization: Cookies.get('reqToKen') },
    }).then((res) => {
        return !!(res.data && res.data.success && res.data.data);
    }).catch(() => false);
}

function checkExamTicket() {
    return axios.get('/zhaopinapi/exam-admission-tickets/currently', {
        headers: { Authorization: Cookies.get('reqToKen') },
    }).then((res) => {
        return !!(res.data && res.data.success && res.data.data);
    }).catch(() => false);
}

function getCurrentApplicationPositionId() {
    return axios.get('/zhaopinapi/job-applications/currently', {
        headers: { Authorization: Cookies.get('reqToKen') },
    }).then((res) => {
        const app = res.data && res.data.data;
        if (!app) {
            return null;
        }
        return app.position_id != null ? app.position_id : app.positionId;
    }).catch(() => null);
}

function checkTicketPrintWindow(positionId) {
    return axios.get('/zhaopinapi/exam-ticket-print-window/effective', {
        headers: { Authorization: Cookies.get('reqToKen') },
        params: positionId != null ? { positionId } : {},
    }).then((res) => {
        if (res.data && res.data.success && res.data.data) {
            return res.data.data;
        }
        return { inWindow: false, blockMessage: '暂未到准考证打印开放时间，开放时间另行通知' };
    }).catch(() => ({
        inWindow: false,
        blockMessage: '暂未到准考证打印开放时间，开放时间另行通知',
    }));
}

function promptRegisterFirst() {
    return MessageBox.alert('请先报名', '提示', {
        confirmButtonText: '我知道了',
        type: 'warning',
    });
}

function promptNoTicket() {
    return MessageBox.alert('暂无准考证信息', '提示', {
        confirmButtonText: '我知道了',
        type: 'warning',
    });
}

function promptTicketNotOpen(message) {
    return MessageBox.alert(message || '暂未到准考证打印开放时间，开放时间另行通知', '提示', {
        confirmButtonText: '我知道了',
        type: 'warning',
    });
}

/** 与顶部导航「打印准考证」、路由守卫一致的进入校验 */
export function validatePrintTicketAccess() {
    return checkSubmittedApplication().then((hasApplication) => {
        if (!hasApplication) {
            return promptRegisterFirst().then(() => false);
        }
        return checkExamTicket().then((hasTicket) => {
            if (!hasTicket) {
                return promptNoTicket().then(() => false);
            }
            return getCurrentApplicationPositionId().then((positionId) => {
                return checkTicketPrintWindow(positionId).then((effective) => {
                    if (effective.inWindow) {
                        return true;
                    }
                    return promptTicketNotOpen(effective.blockMessage).then(() => false);
                });
            });
        });
    });
}
